import { EVENTS } from './events'
import { isEqual } from 'lodash'
declare const window: any

let actionTimeout: any = null

export const mixpanelTrack = (eventName: string, data: any = {}) => {
  const mixpanel = window.homeviewsMixpanel
  const name = EVENTS[eventName] || eventName

  setTimeout(() => {
    actionTimeout = false
  }, 1000)

  // Check if event sent is last 1000ms is not the same, if so do not send it
  if (isEqual(actionTimeout, { eventName, data })) {
    return
  }

  console.log(name, data)

  actionTimeout = {
    eventName,
    data,
  }

  if (mixpanel?.config?.token && eventName) {
    mixpanel.track(name, data)
  }
}
